import { BehaviorSubject, Observable, Subject} from "rxjs";
import { Component, Inject } from "@angular/core";
import { DiscoveryService } from "../discovery.service";
import { IApiDocumentation } from "heracles/DataModel/IApiDocumentation";
import { IClass } from "heracles/DataModel/IClass";
import { IWebResource } from "heracles/DataModel/IWebResource";
import { IResource } from "hydraclient.js/types/src/DataModel/IResource";

@Component({
  selector: "hydra-discovery",
  templateUrl: "./hydra-discovery.component.html",
  styleUrls: ["./hydra-discovery.component.scss"]
})
export class HydraDiscoveryComponent {
  public readonly resource: Observable<IWebResource>;
  public readonly documentation: Observable<IApiDocumentation>;
  public readonly selectedResource: Observable<string>;

  protected currentPanel: string = null;

  private readonly _selectedResource: Subject<string>;

  public constructor(@Inject(DiscoveryService) private discoveryService: DiscoveryService) {
    this.documentation = this.discoveryService.documentation;
    this.resource = this.discoveryService.resource;
    this._selectedResource = new BehaviorSubject(null);
    this.selectedResource = this._selectedResource.asObservable();
  }

  public makeLabelFor(resource: any): string {
    return this.discoveryService.makeLabelFor(resource);
  }

  public selectClassOf(value: IClass) {
    this.discoveryService.selectClassOf(value);
  }

  public load(resource: IResource): void {
    this.discoveryService.load(resource);
  }
}
